module.exports = __webpack_public_path__ + "static/img/1.3637831.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/VascularSystem/Meeting711/images/1.png
// module id = W9wu
// module chunks = 4